<div class="spen-ly-modal" id="modal">
  <div class="modal-dialog">
    <div class="album-inner">
      <div class="modal-heading">
        @if (layoutService.isTabletDownView.value) {
          <a (click)="onClose()"><i class="fa fa-times"></i></a>
        }
        <h2 class="heading-text">追加先の選択</h2>
      </div>

      <div class="scrollable-modal-content">
        <div
          class="modal-content"
          infinite-scroll
          infiniteScrollDistance="1"
          infiniteScrollThrottle="200"
          [infiniteScrollDisabled]="!nextPageParams"
          [scrollWindow]="false"
          (scrolled)="onLoadMore()"
        >
          <div class="albums-input">
            <input class="spen-mod-input-text" type="text" placeholder="キーワードを入力してください" #searchInput />
            <button class="spen-mod-btn" (click)="onSearch()">
              {{ layoutService.isTabletDownView.value ? '検索' : '検索する' }}
            </button>
          </div>
          <div class="error-popup">
            @if (isShowError) {
              <div class="spen-mod-error-content">アルバムを選択してください。</div>
            }
          </div>

          <div class="list-header">
            <h3>アルバムリスト</h3>
          </div>

          @if (isLoading || searchedResults.length > 0) {
            <div class="albums-list">
              @for (album of searchedResults; track album.id) {
                <div
                  class="album-item"
                  data-cy="album-item"
                  (change)="selectAlbum(album)"
                  [class.has-hover-effect]="!layoutService.isTabletDownView.value"
                >
                  <label class="spen-mod-radio">
                    <input class="radio" type="radio" name="radio" [checked]="newSelectAlbum?.id === album.id" />
                    <i class="fa"></i>
                    <img class="album-image" data-cy="album-image" [src]="album.image?.thumbnail || '/assets/images/album.svg'" />
                    <p class="truncate-text">{{ album.title }}</p>
                  </label>
                </div>
              }
              @if (isLoading) {
                <div class="spen-mod-flex-loading">
                  <div class="loading-icon"></div>
                </div>
              }
            </div>
          }
        </div>
        <div class="modal-footer">
          <div class="modal-actions is-right-actions">
            <button class="spen-mod-btn" (click)="onClose()">キャンセル</button>
            <button class="spen-mod-btn is-primary" data-cy="submit-work-album" (click)="onSubmit()">選択する</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
